import React from 'react';
import styled from 'styled-components';
import { colors } from '../../healtheraComponents';

const DetailsLine = ({ title, value }) => {
  return (
    <DetailsLineContainer>
      <DetailsField>{title}</DetailsField>
      <DetailsFieldValue>{value}</DetailsFieldValue>
    </DetailsLineContainer>
  );
};

export default DetailsLine;

const DetailsLineContainer = styled.p`
  margin: 0;
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
`;

const DetailsField = styled.span`
  display: block;
  color: ${colors.FADED};
`;

const DetailsFieldValue = styled.span`
  display: block;
  color: ${colors.DARK};
  text-align: end;
`;
